import type { FC } from 'react';

import type { IconProps } from './BaseIcon';
import { BaseIcon } from './BaseIcon';

export const TwilioIconAlt: FC<IconProps> = ({
  preserveColor = false,
  ...props
}) => (
  <BaseIcon viewboxSize="md" {...props}>
    <path
      d="M9.98535 0.0146484C4.48023 0.0146484 0 4.49488 0 10C0 15.5051 4.48023 19.9854 9.98535 19.9854C15.5198 20.0146 20 15.5344 20 10C20 4.4656 15.5198 0.0146484 9.98535 0.0146484ZM9.98535 17.3792C5.94436 17.3792 2.63543 14.0703 2.63543 10C2.63543 5.95901 5.94436 2.65008 9.98535 2.65008C14.0556 2.65008 17.3646 5.95901 17.3646 10C17.3646 14.0703 14.0556 17.3792 9.98535 17.3792Z"
      fill={preserveColor ? '#E31E26' : undefined}
    />
    <path
      d="M12.4743 9.59025C13.6226 9.59025 14.5534 8.65943 14.5534 7.51119C14.5534 6.36296 13.6226 5.43213 12.4743 5.43213C11.3261 5.43213 10.3953 6.36296 10.3953 7.51119C10.3953 8.65943 11.3261 9.59025 12.4743 9.59025Z"
      fill={preserveColor ? '#E31E26' : undefined}
    />
    <path
      d="M12.4743 14.5683C13.6226 14.5683 14.5534 13.6375 14.5534 12.4892C14.5534 11.341 13.6226 10.4102 12.4743 10.4102C11.3261 10.4102 10.3953 11.341 10.3953 12.4892C10.3953 13.6375 11.3261 14.5683 12.4743 14.5683Z"
      fill={preserveColor ? '#E31E26' : undefined}
    />
    <path
      d="M7.4963 14.5683C8.64453 14.5683 9.57536 13.6375 9.57536 12.4892C9.57536 11.341 8.64453 10.4102 7.4963 10.4102C6.34806 10.4102 5.41724 11.341 5.41724 12.4892C5.41724 13.6375 6.34806 14.5683 7.4963 14.5683Z"
      fill={preserveColor ? '#E31E26' : undefined}
    />
    <path
      d="M7.4963 9.59025C8.64453 9.59025 9.57536 8.65943 9.57536 7.51119C9.57536 6.36296 8.64453 5.43213 7.4963 5.43213C6.34806 5.43213 5.41724 6.36296 5.41724 7.51119C5.41724 8.65943 6.34806 9.59025 7.4963 9.59025Z"
      fill={preserveColor ? '#E31E26' : undefined}
    />
  </BaseIcon>
);
